import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';

const CompanyLayer = ({datos, handleChange, handleSave,error}) => {
    const navigate = useNavigate();
    const [disabledButton, setDisabledButton] = useState(false)
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <InputForm
                        name="nombre"
                        label="Nombre Sucursal"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="calle"
                        label="Calle"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="num_exterior"
                        label="Número Exterior"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="num_interior"
                        label="Número Interior"
                        datos={datos}
                        change={handleChange}
                        error={error}/>
                    <InputForm
                        col="col-sm-6"
                        name="colonia"
                        label="Colonia"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="codigo_postal"
                        label="Código Postal"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="ciudad"
                        label="Ciudad"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <InputForm
                        col="col-sm-6"
                        name="estado"
                        label="Estado"
                        datos={datos}
                        change={handleChange}
                        error={error}
                        required/>
                    <div className="form-switch switch-primary d-flex align-items-center gap-2 mt-2 mx-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="switch1"
                            defaultChecked={true}
                        />
                        <label
                            className="form-check-label line-height-1 fw-medium text-secondary-light"
                            htmlFor="switch1"
                        >
                            Es visible?
                        </label>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default CompanyLayer;